import _ from 'lodash';
import { CfsModel } from '../../../../services/index';
import { Component, EventEmitter, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';

@Component({
  selector: 'cfs-selector',
  templateUrl: 'cfs-selector.html'
})

export class CfsSelector {
  _cfsList:any;
  @Input() savedCfs;

  @Input() set cfsList(cfsList:any){
    if(this.savedCfs != null) {
      this.selectedCfs = this.savedCfs;
      this.codeControl.setValue(this.selectedCfs.code);
      this.nameControl.setValue(this.selectedCfs.cfsName);
      this.addressControl.setValue(this.selectedCfs.address);
      this.personControl.setValue(this.selectedCfs.person);
    }
    if(!cfsList) return;
    this._cfsList = cfsList;
  }
    
  get cfsList(): any {
    return this._cfsList;
  }

  @Output() onCfsSelect: EventEmitter<CfsModel> = new EventEmitter();

  

  selectedCfs: CfsModel = new CfsModel();
  filteredCfsList: Array<CfsModel>;
  showCfsByCode: boolean = false;
  showCfsByName: boolean = false;

  codeControl: FormControl = new FormControl();
  nameControl: FormControl = new FormControl();
  addressControl: FormControl = new FormControl({value: '', disabled: true});
  personControl: FormControl = new FormControl({value: '', disabled: true});

  focusedCodeIndex: number = 0;
  focusedNameIndex: number = 0;

  @ViewChild("codeCon")
  codeElRef: ElementRef;

  @ViewChild("nameCon")
  nameElRef: ElementRef;

  @ViewChild("codeList")
  codeListElRef: ElementRef;

  @ViewChild("nameList")
  nameListElRef: ElementRef;



  ngOnInit() {
    if(this.savedCfs != null) {
      this.selectedCfs = this.savedCfs;
      this.codeControl.setValue(this.selectedCfs.code);
      this.nameControl.setValue(this.selectedCfs.cfsName);
      this.addressControl.setValue(this.selectedCfs.address);
      this.personControl.setValue(this.selectedCfs.person);
    }
  }

  setFilteredCfsList(event, codeOrName) {
    if(!event) return;

    let keyword = event.target.value.toString();

    if(!keyword) {
      this.selectedCfs = null;
      this.filteredCfsList = null;
      this.showCfsByCode = false;
      this.showCfsByName = false;
      return;
    }

    if(keyword.length > 0) {
      keyword = _.trim(keyword);
      if(codeOrName == 'code') {
        this.showCfsByCode = true;
        let filteredCfsList = _.map(_.filter(this.cfsList,
                                (cfs) => {
                                  if (keyword.length <= 0) return true;
                                  else if (_.trim(cfs.code).indexOf(keyword) >= 0) return true;
                                  else return false;
                                }));
        this.filteredCfsList = _.sortBy(filteredCfsList,
                              (cfs) => {
                                let nmIndex = _.trim(cfs.code).indexOf(keyword);
                                if (nmIndex < 0) nmIndex = 999;
                                return _.min([nmIndex])
                              });
      } else {
        this.showCfsByName = true;
        let filteredCfsList = _.map(_.filter(this.cfsList,
                                (cfs) => {
                                  if (keyword.length <= 0) return true;
                                  else if (_.trim(cfs.cfsName).indexOf(keyword) >= 0) return true;
                                  else return false;
                                }));
        this.filteredCfsList = _.sortBy(filteredCfsList,
                                (cfs) => {
                                  let nmIndex = _.trim(cfs.cfsName).indexOf(keyword);
                                  if (nmIndex < 0) nmIndex = 999;
                                  return _.min([nmIndex])
                                });
      }
    }
  }


  handleKeyDown(event) {
    if (event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40 ) return;

		let suggestListDom = null;
		let focusedIndex = null;
		let type = null;

		if (event.target === this.codeElRef.nativeElement ) {
			type = 'code';
			suggestListDom = this.codeListElRef.nativeElement;
			focusedIndex = this.focusedCodeIndex;
		} else if (event.target === this.nameElRef.nativeElement ) {
			type = 'name';
			suggestListDom = this.nameListElRef.nativeElement;
			focusedIndex = this.focusedNameIndex;
    }
    
    let suggestListItem = null;
    if (suggestListDom) suggestListItem = suggestListDom.querySelectorAll('li');


		switch (event.keyCode) {
			case 13: // enter
        if (type === 'code') {
					if (_.isEmpty(this.filteredCfsList) || !this.focusedCodeIndex == null || !this.showCfsByCode) return;
					let item = this.filteredCfsList[this.focusedCodeIndex];
          this.cfsSelected(item, 'code');
          this.showCfsByCode = false;
				} else if (type === 'name') {
					if (_.isEmpty(this.filteredCfsList) || !this.focusedNameIndex == null || !this.showCfsByName) return;
					let item = this.filteredCfsList[this.focusedNameIndex];
          this.cfsSelected(item, 'name');
          this.showCfsByName = false;
				}
			  break;
			case 27: // escape
					this.showCfsByCode = false;
          this.showCfsByName = false;
          
          if (type === 'code') {
            if (this.selectedCfs) this.codeControl.setValue(this.selectedCfs.code);
          } else {
            if (this.selectedCfs) this.nameControl.setValue(this.selectedCfs.cfsName);
          }
			  break;
			case 38: // up
        focusedIndex--;
        if (focusedIndex < 0) focusedIndex = 0;
        // suggestListItem[focusedIndex].scrollIntoViewIfNeeded(true);
        scrollIntoViewIfNeeded(suggestListItem[focusedIndex], true);
			  break;
			case 40: // down
				focusedIndex++;
        if (focusedIndex > suggestListItem.length - 1) focusedIndex = suggestListItem.length - 1;
        //suggestListItem[focusedIndex].scrollIntoViewIfNeeded(false);
        scrollIntoViewIfNeeded(suggestListItem[focusedIndex], false);
        break;
			default: return;
		}

		
		if (type === 'code') {
			if (focusedIndex != this.focusedCodeIndex) this.focusedCodeIndex = focusedIndex;
		} else if (type === 'name') {
			if (focusedIndex != this.focusedNameIndex) this.focusedNameIndex = focusedIndex;
		}
		event.preventDefault();
	}
  

  handleCodeBlur($event) {
    if (this.showCfsByCode) this.showCfsByCode = false;

    if (this.selectedCfs && $event.target.value) {
      this.codeControl.setValue(this.selectedCfs.code);
    }
  }

  handleNameBlur($event) {
    if (this.showCfsByName) this.showCfsByName = false;

    if (this.selectedCfs && $event.target.value) {
      this.nameControl.setValue(this.selectedCfs.cfsName);
    }
  }

  cfsSelected(cfs, codeOrName) {
    this.selectedCfs = cfs;
    this.onCfsSelect.emit(cfs);
    this.showCfsByCode = false;
    this.showCfsByName = false;
    this.codeControl.setValue(cfs.code);
    this.nameControl.setValue(cfs.cfsName);
    this.addressControl.setValue(cfs.address);
    this.personControl.setValue(cfs.person);
  }


}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/forwarder/detail/cfs-selector.ts